module.exports = __webpack_public_path__ + "static/img/top-banner2-t.ef245a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/top-banner2-t.png
// module id = sXs0
// module chunks = 1